<script lang="ts" setup>
import type { CardItem } from '@/components/ui/types'
import _shuffle from 'lodash-es/shuffle'
import accVideo from '@/assets/cards/acc.mp4'
import bassVideo from '@/assets/cards/bass.mp4'
import eleVideo from '@/assets/cards/ele.mp4'
import pianoVideo from '@/assets/cards/piano.mp4'
import drumsVideo from '@/assets/cards/drums.mp4'
import { getAppUrl } from '@/lib/helpers'

const { fetchTutorials } = useTutorials()

const { data: tutorials } = fetchTutorials()

const videos: CardItem[] = _shuffle([
  { src: accVideo, type: 'video' },
  { src: bassVideo, type: 'video' },
  { src: eleVideo, type: 'video' },
  { src: pianoVideo, type: 'video' },
  { src: drumsVideo, type: 'video' },
])

const items = computed(() => [
  ...tutorials.value.latest.slice(0, 1).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  ...tutorials.value.random.slice(0, 1).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  videos[0],
  ...tutorials.value.latest.slice(1, 2).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  ...tutorials.value.random.slice(1, 2).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  videos[1],
  ...tutorials.value.latest.slice(2, 3).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  ...tutorials.value.random.slice(2, 3).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  videos[2],
  ...tutorials.value.latest.slice(3, 4).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  ...tutorials.value.random.slice(3, 4).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  videos[3],
  ...tutorials.value.latest.slice(4, 5).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  ...tutorials.value.random.slice(4, 5).map(tutorial => ({
    src: tutorial.image.url,
    type: 'image',
  }) as CardItem),
  videos[4],
])

const display = useDisplay()

const slidesPerView = computed(() => {
  if (display.mdAndUp.value) return 6
  if (display.smAndUp.value) return 5
  return 3
})
</script>

<template>
  <v-container>
    <div
      class="text-center text-white"
      :style="{
        textShadow: '0 4px 44px rgba(0, 0, 0, 0.25)',
        fontSize: 'clamp(3.5rem, 10vw, 6.4rem)',
        lineHeight: '105%',
        letterSpacing: '-4.8px',
        background: 'linear-gradient(180deg, #fff 60%, rgba(255, 255, 255, .3))',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }"
    >
      Miejsce rozwoju<br>
      służby uwielbienia
    </div>
  </v-container>
  <v-no-ssr>
    <ui-cards-swiper
      :style="{ maxWidth: $vuetify.display.mdAndUp ? '880px' : undefined }"
      :items="items"
      :slides-per-view="slidesPerView"
    />
  </v-no-ssr>
  <v-container class="d-flex flex-column ga-6">
    <div
      class="text-subtitle-1 text-gray-500 font-weight-regular text-center mx-auto"
      :style="{ maxWidth: '510px' }"
    >
      Największa <span class="text-primary">baza pieśni i materiałów,</span>
      stworzona z myślą o służbie muzycznej w lokalnym kościele.
    </div>

    <div class="d-flex flex-row ga-3 mx-auto">
      <v-btn
        :text="$auth.check ? 'Korzystaj' : 'Dołącz teraz'"
        color="primary-800"
        rounded="xll"
        flat
        :href="getAppUrl()"
      />
      <v-btn
        text="Dowiedz się więcej"
        color="primary-800"
        variant="outlined"
        rounded="xll"
        border
        :active="false"
        to="/#wszystko-w-jednym-miejscu"
      />
    </div>
  </v-container>
</template>
